"use strict";
var PopStore_1 = require('../PopStore');
var GroupStore_1 = require('../GroupStore');
var Options_1 = require('../Options');
var PopStateType_1 = require('../PopStateType');
var PopChainManager_1 = require('../PopChainManager');
var UserAgentUtil_1 = require('../UserAgentUtil');
var TimeoutManager_1 = require('../TimeoutManager');
var camelize = require('camelize');
var closest = require('closest');
var positioner = require('positioner');
var createZIndexManager = require('z-index-manager').default;
var createEscapeStack = require('escape-stack').default;
var PopEngine = (function () {
    function PopEngine() {
        this._transitionendCallbacks = {};
        this._escapeStack = null;
        this._scrollListener = null;
        this._zIndexManager = null;
        this._zIndexManager = createZIndexManager();
        this._escapeStack = createEscapeStack();
        this._scrollListener = this._positionOpenPops.bind(this);
    }
    PopEngine.prototype.isPopTarget = function (el) {
        return !!(el && el.hasAttribute('popgun'));
    };
    PopEngine.prototype.isPopForTrigger = function (el, trigger) {
        return this.isPopTarget(el) && Options_1.default.fromElement(el).containsEventTrigger(trigger.eventType);
    };
    PopEngine.prototype.isPop = function (el) {
        return !!(el && (el.hasAttribute('pop') || closest(el, 'div[pop=""]')));
    };
    // Add group to groupStore when registering a group
    PopEngine.prototype.addGroupOptionsToGroupStore = function (groupId, group) {
        GroupStore_1.default.add(groupId, group);
    };
    // Get group
    PopEngine.prototype.getGroupOptionsFromGroupId = function (groupId) {
        return GroupStore_1.default.get(groupId);
    };
    // Add pop to popStore when caching a pop
    PopEngine.prototype.addPopToPopStore = function (groupId, pop) {
        PopStore_1.default.add(groupId, pop);
    };
    PopEngine.prototype.getPopFromGroupId = function (groupId) {
        return PopStore_1.default.get(groupId);
    };
    PopEngine.prototype.popTopPop = function () {
        this._escapeStack.pop();
    };
    PopEngine.prototype.isPopAlreadyOpenForGroup = function (groupId) {
        if (this.getPopFromGroupId(groupId)) {
            return (this.getPopFromGroupId(groupId).state === PopStateType_1.default.SHOWING ||
                this.getPopFromGroupId(groupId).state === PopStateType_1.default.PRE_HIDE);
        }
        return false;
    };
    PopEngine.prototype.isPopAlreadyOpenForTarget = function (targetElement) {
        var groupId = targetElement.getAttribute('popgun-group');
        if (this.getPopFromGroupId(groupId)) {
            return ((this.getPopFromGroupId(groupId).state === PopStateType_1.default.SHOWING ||
                this.getPopFromGroupId(groupId).state === PopStateType_1.default.PRE_HIDE) &&
                (this.getPopFromGroupId(groupId).targetEl === targetElement));
        }
        return false;
    };
    PopEngine.prototype.setState = function (pop, state, targetOpts, result, renotify) {
        if (state !== pop.state || renotify) {
            pop.state = state;
            this._fireEvent(state, pop);
        }
    };
    PopEngine.prototype.listenForScroll = function () {
        document.addEventListener('scroll', this._scrollListener, true);
    };
    PopEngine.prototype.setPosition = function (pop, container) {
        var nose = container.getElementsByClassName('nose-triangle')[0];
        var positionOpts = {
            cushion: pop.opts.cushion,
            containerCushion: pop.opts.containerCushion,
            alignmentOffset: pop.opts.alignmentOffset,
            arrowElement: nose
        };
        positioner(container, pop.targetEl, positionOpts)
            .at(pop.opts.placement, pop.opts.optimizePlacement, pop.opts.alignment);
    };
    PopEngine.prototype.createPopElement = function (targetElement) {
        var container = document.createElement('div');
        var nose = document.createElement('div');
        container.classList.add('popover');
        container.classList.add('hidden');
        container.setAttribute('pop-id', targetElement.getAttribute('popgun-group'));
        container.setAttribute('pop', '');
        nose.setAttribute('class', 'nose-triangle');
        container.setAttribute('style', 'z-index: ' + this._zIndexManager.getHighest().toString() + ';');
        container.appendChild(nose);
        return container;
    };
    PopEngine.prototype.showPop = function (targetElement, isPinned, pop) {
        if (!pop.opts.disable) {
            var delay = isPinned ? 0 : pop.opts.showDelay;
            var groupId_1 = targetElement.getAttribute('popgun-group');
            var isAlreadyShowing_1 = this.isPopAlreadyOpenForGroup(groupId_1);
            // clear any timeouts and do a timeout and show pop
            TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().timeToHoverOnPop, groupId_1);
            TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().hoverdelay, null);
            TimeoutManager_1.default.getTimeouts().hoverdelay = setTimeout(function () {
                var animationEndStates = {};
                var container = this._maybeCreateOrReusePopover(isAlreadyShowing_1, targetElement, pop, groupId_1);
                this.addPopToPopStore(targetElement.getAttribute('popgun-group'), pop);
                if (UserAgentUtil_1.default.isSafari() && !this._transitionendCallbacks[groupId_1]) {
                    this._transitionendCallbacks[groupId_1] = this._removeHiddenClass.bind(this);
                    document.querySelector('div[pop-id="' + groupId_1 + '"]').addEventListener('transitionend', this._transitionendCallbacks[groupId_1], true);
                }
                if (isPinned) {
                    PopChainManager_1.default.maybePinOrUnpinPopAndParentPops(targetElement, true);
                }
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().popHover, null);
                // CONTENT SETUP
                this.setState(pop, PopStateType_1.default.CONTENT_SETUP, pop.opts, null, false);
                if (pop.opts.darkStyle) {
                    container.classList.add('dark-style');
                }
                else {
                    container.classList.remove('dark-style');
                }
                container.appendChild(pop.popOver.element);
                // PRE POSITION
                this.setState(pop, PopStateType_1.default.PRE_POSITION, pop.opts, null, false);
                TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().position, null);
                TimeoutManager_1.default.getTimeouts().position = setTimeout(function () {
                    this.setPosition(pop, container);
                    // PRE SHOW
                    this.setState(pop, PopStateType_1.default.PRE_SHOW, pop.opts, null, false);
                    TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().hoverdelay, null);
                    if (!pop.opts.disableClickOff) {
                        TimeoutManager_1.default.getHandlers()[groupId_1] = this._escapeStack.add(function () {
                            this.synchronousHidePop(pop.targetEl, false);
                            return true;
                        }.bind(this));
                    }
                    // SHOWING
                    this.setState(pop, PopStateType_1.default.SHOWING, pop.opts, null, false);
                    if (!UserAgentUtil_1.default.isSafari()) {
                        container.classList.remove('hidden');
                    }
                }.bind(this));
            }.bind(this), delay);
        }
    };
    PopEngine.prototype.hidePop = function (targetElement, hideFullChain) {
        var groupId = targetElement.getAttribute('popgun-group') || targetElement.getAttribute('pop-id');
        var pop = this.getPopFromGroupId(groupId);
        TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().hoverdelay, null);
        if (pop) {
            this.setState(pop, PopStateType_1.default.PRE_HIDE, pop.opts, null, false);
            TimeoutManager_1.default.getTimeouts().timeToHoverOnPop[groupId] = setTimeout(function () {
                this.synchronousHidePop(targetElement, hideFullChain);
            }.bind(this), pop.opts.timeToHoverOnPop);
        }
    };
    PopEngine.prototype.synchronousHidePop = function (targetElement, hideFullChain) {
        var groupId = targetElement.getAttribute('popgun-group') || targetElement.getAttribute('pop-id');
        var pop = this.getPopFromGroupId(groupId);
        if (pop) {
            this.setState(pop, PopStateType_1.default.PRE_HIDE, pop.opts, null, false);
            var popChain = PopChainManager_1.default.getPopChain(pop, hideFullChain);
            popChain.forEach(function (p) {
                PopChainManager_1.default.removeParentChildRelationship(p);
                var popOver = closest(p.popOver.element, 'div[pop=""]');
                if (popOver) {
                    var g = popOver.getAttribute('pop-id');
                    p.targetEl.removeAttribute('pinned-pop');
                    TimeoutManager_1.default.maybeClearHandler(TimeoutManager_1.default.getHandlers()[g]);
                    this.setState(p, PopStateType_1.default.HIDDEN, p.opts, null, false);
                    if (!!popOver) {
                        document.body.removeChild(popOver);
                        this._fireEvent(PopStateType_1.default.CONTENT_REMOVE, p);
                    }
                    this.addPopToPopStore(g, null);
                }
            }, this);
        }
    };
    PopEngine.prototype._orphanPop = function (pop) {
        pop.targetEl.removeAttribute('pinned-pop');
        pop.targetEl.removeAttribute('unpinned-pop');
        if (!!pop && !!pop.childPops.length) {
            pop.childPops.forEach(function (child) {
                this.synchronousHidePop(child.targetEl, false);
            }, this);
        }
        if (!!pop && !!pop.parentPop) {
            var idx = pop.parentPop.childPops.indexOf(pop);
            if (idx !== -1) {
                pop.parentPop.childPops.splice(idx, 1);
            }
        }
    };
    PopEngine.prototype._maybeCreateOrReusePopover = function (isAlreadyShowing, targetElement, pop, groupId) {
        var container = document.querySelector('div[pop-id="' + groupId + '"]');
        var oldPop = this.getPopFromGroupId(groupId);
        if (oldPop && oldPop.targetEl && !pop.opts.reusePopover) {
            this.synchronousHidePop(oldPop.targetEl, false);
        }
        this._maybeSetParentChildRelationship(pop);
        if (isAlreadyShowing && !!container) {
            // remove references to old popover
            this._orphanPop(oldPop);
        }
        if (isAlreadyShowing && !!container && !!pop.opts.reusePopover) {
            // if pop is already showing for group, reuse
            container.removeChild(container.getElementsByClassName('pop-content')[0]);
            this._fireEvent(PopStateType_1.default.CONTENT_SWAP, oldPop);
            TimeoutManager_1.default.maybeClearHandler(TimeoutManager_1.default.getHandlers()[groupId]);
        }
        else {
            container = this.createPopElement(targetElement);
            if (!!pop.opts.tipClass) {
                var classes = pop.opts.tipClass.split(' ');
                classes.forEach(function (className) {
                    container.classList.add(className);
                });
            }
            document.body.appendChild(container);
        }
        return container;
    };
    PopEngine.prototype._fireEvent = function (state, pop) {
        var event = document.createEvent('CustomEvent');
        event.initCustomEvent(camelize('Popgun_' + state), true, true, { 'pop': pop });
        pop.targetEl.dispatchEvent(event);
    };
    PopEngine.prototype._getParentPop = function (pop) {
        var parentEl = closest(pop.targetEl, 'div[pop=""]');
        if (parentEl) {
            return this.getPopFromGroupId(parentEl.getAttribute('pop-id'));
        }
        return null;
    };
    PopEngine.prototype._positionOpenPops = function () {
        var popElementsList = Array.prototype.slice.call(document.body.getElementsByClassName('popover'));
        popElementsList.forEach(function (popOver) {
            var groupId = popOver.getAttribute('pop-id');
            TimeoutManager_1.default.maybeClearTimeout(TimeoutManager_1.default.getTimeouts().scrollTimer, groupId);
            TimeoutManager_1.default.getTimeouts().scrollTimer[groupId] = setTimeout(function () {
                this.setPosition(this.getPopFromGroupId(groupId), popOver);
            }.bind(this), 100);
        }, this);
    };
    PopEngine.prototype._maybeSetParentChildRelationship = function (pop) {
        if (!!PopChainManager_1.default.isNestedPop(pop)) {
            var parent_1 = this.getPopFromGroupId(closest(pop.targetEl, '[pop]', true).getAttribute('pop-id'));
            PopChainManager_1.default.setParentChildRelationship(parent_1, pop);
        }
    };
    PopEngine.prototype._removeHiddenClass = function (e) {
        var groupId = e.target.getAttribute('pop-id');
        e.target.removeEventListener(e.type, this._transitionendCallbacks[groupId], true);
        this._transitionendCallbacks[groupId] = null;
        e.target.classList.remove('hidden');
    };
    return PopEngine;
}());
exports.PopEngine = PopEngine;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new PopEngine();
